import {Component, OnInit} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Application} from '../../../domain/onBoarding/application';
import {ApplicationService} from '../../../services/application.service';
import {environment} from '../../../../environments/environment';
import {EKycStatus} from '../../../enums/EKycStatus';
import {ApplicationBody, ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import {LocalStorageService} from 'angular-2-local-storage';


@Component({
  selector: 'app-end-screen',
  templateUrl: './end-screen.component.html',
  styleUrls: ['./end-screen.component.scss']
})
export class EndScreenComponent extends CommonComponent implements OnInit {

  cardTextStroked = environment.cardTextStroked;
  borderCard = environment.borderCard;
  textWhiteCard = environment.textWhiteCard;

  application: Application;
  appStatus: string;
  kycStatus: string;
  appRejected: boolean;
  card = environment.cardPan;
  name: string;
  applicationDenied: boolean;
  instantIssue = false;
  setApplicationLoading = true;
  responseServicesOk = false;

  constructor(
    router: Router,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    private applicationService: ApplicationService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private configurationService: ConfigurationService,
    private localStorage: LocalStorageService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;
  }

  ngOnInit(): void {
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    this.applicationService.getApplicationReponse(this.application.body.applicationHash).subscribe(
      (response: any) => {
        if (response.mediaAccess) {
          this.card = response.mediaAccess;
        }
        this.setApplicationLoading = false;
        this.responseServicesOk = true;
      }, error => {
        this.setApplicationLoading = false;
        this.msgError(error);
      }
      ).add(
      () => {
        this.init();
      }
    );
  }
  init(){
    this.name = (this.application?.body.firstName ? this.application?.body.firstName : '')  + ' ' +
      (this.application?.body.lastName ? this.application?.body.lastName : '');
    this.name = this.name.length < 30 ? this.name : this.name.substring(0, 30);
    this.appStatus = this.application?.body.status;
    this.kycStatus = this.application?.body.kycStatus;
    this.appRejected = this.application?.body.applicationRejected;
    this.instantIssue = this.configurationService.application.instantIssue;
    this.applicationDenied = (this.appStatus === ApplicationStatus.BLACK_LISTED ||
      this.kycStatus === EKycStatus.BLACK_LISTED ||
      this.appStatus === ApplicationStatus.DENIED) &&
      !this.appRejected;
    this.application = null;
    this.applicationService.clearApplication();
    scroll(0, 0);
  }

  finish() {
    this.router.navigate(['/']);
  }

  finishLogin() {
    this.router.navigate(['/login']);
  }

}
